export default __webpack_public_path__ + "static/media/2439.a54dfe67.png";